
      import bootstrap from "/src/bootstrap.ts";
      bootstrap();
    